export default {
  app: {
    tradeOffers: {
      country: 'Krajina',
      loginPrompt: 'Ak chcete zobraziť súkromné obchodné ponuky, musíte {0}.',
      logIn: 'sa prihlásiť',
    },
  },
};
